module.exports = __webpack_public_path__ + "img/banner_team.7f71fdbc.jpg";